import { render, staticRenderFns } from "./CommentsTest.vue?vue&type=template&id=07f71008&scoped=true"
import script from "./CommentsTest.vue?vue&type=script&lang=js"
export * from "./CommentsTest.vue?vue&type=script&lang=js"
import style0 from "./CommentsTest.vue?vue&type=style&index=0&id=07f71008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f71008",
  null
  
)

export default component.exports